import { sortMapListings } from '../../models/map-result-sort';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CarState } from '../states/car.state';

export const selectCarState = createFeatureSelector<CarState>('car');

export const selectCarSearchResults = createSelector(selectCarState, (state) => state.carResults);

export const selectCarMapSearchResults = createSelector(
  selectCarState,
  (state) => state.carMapResults
);

export const selectCarReportResults = createSelector(selectCarState, (state) => state.carReports);

export const selectTopCarResults = createSelector(selectCarState, (state) => state.topCarResults);

export const selectCar = createSelector(selectCarState, (state) => state.car);

export const selectCarSearchLoading = createSelector(selectCarState, (state) => state.isCarMapView ? state.mapLoading : state.listLoading);

export const selectCarIsSaving = createSelector(selectCarState, (state) => state.isSaving);
export const selectCarSearchError = createSelector(selectCarState, (state) => state.isCarMapView ? state.mapError : state.listError);

export const selectTopCarSearchLoading = createSelector(
  selectCarState,
  (state) => state.topLoading
);

export const selectCarSearchForm = createSelector(selectCarState, (state: CarState) => state.query);
export const selectCarMapSearchForm = createSelector(
  selectCarState,
  (state: CarState) => state.mapQuery
);
export const selectCarReportForm = createSelector(
  selectCarState,
  (state: CarState) => state.reportQuery
);

export const selectCarSort = createSelector(selectCarState, (state) => state.isCarMapView ? state.mapSort : state.sort);

export const selectCarPagination = createSelector(selectCarState, (state) => state.pagination);

export const selectIsCarMapView = createSelector(selectCarState, (state) => state.isCarMapView);

export const selectCarPolygon = createSelector(selectCarState, (state) => state.activePolygon);

export const selectCarPolygonRevision = createSelector(
  selectCarState,
  (state) => state.polygonRevision
);

// A missing response is neutral, not a successful empty search.
export const selectCarSearchEmpty = createSelector(
  selectCarState,
  state => !state.listLoading && !state.listError && state.carResults?.total === 0
);

export const selectCarError = createSelector(selectCarState, state => state.error);

export const selectCarMapLoading = createSelector(selectCarState, state => state.mapLoading);
export const selectCarMapError = createSelector(selectCarState, state => state.mapError);

export const selectCarMapSort = createSelector(selectCarState, state => state.mapSort);
export const selectCarMapListItems = createSelector(selectCarMapSearchResults, selectCarMapSort,
  (result, sort) => sortMapListings(result?.items ?? [], sort));
